import SldsButton from '../library/SldsButton';
import SldsBadge from '../library/SldsBadge';
import SldsButtonGroup from '../library/SldsButtonGroup';
import SldsColorPicker from '../library/SldsColorPicker';
import SldsDataTable from '../library/SldsDataTable';
import SldsPath from '../library/SldsPath';
import SldsPill from '../library/SldsPill';
import SldsProgressBar from '../library/SldsProgressBar';
import SldsProgressIndicator from '../library/SldsProgressIndicator';
import SldsVerticalNavigation from '../library/SldsVerticalNavigation';
import SldsRadioButtonGroup from '../library/SldsRadioButtonGroup';
import SldsCheckboxButton from '../library/SldsCheckboxButton';
import SldsCheckboxToggle from '../library/SldsCheckboxToggle';


const ComponentLibrary = () => {
  return (
    <div className="slds-grid slds-wrap slds-align_absolute-center" style={{ gap: '1rem' }}>
      <div className="slds-col slds-size_12-of-12 slds-p-around_large slds-align_absolute-center"><SldsButton /></div>
      <div className="slds-col slds-size_6-of-12 slds-p-around_large slds-align_absolute-center"><SldsRadioButtonGroup /></div>
      <div className="slds-col slds-size_12-of-12 slds-p-around_large slds-align_absolute-center"><SldsBadge /></div>

      <div className="slds-col slds-size_3-of-12"><SldsButtonGroup /></div>
      <div className="slds-col slds-size_3-of-12 slds-m-horizontal_x-large"><SldsColorPicker /></div>
      <div className="slds-col slds-size_3-of-12"><SldsVerticalNavigation /></div>

      <div className="slds-col slds-size_1-of-1 slds-p-around_large"><SldsProgressBar /></div>

      <div className="slds-col slds-size_3-of-12 slds-p-around_large"><SldsCheckboxButton /></div>
      <div className="slds-col slds-size_3-of-12 slds-p-around_large"><SldsCheckboxToggle /></div>
      <div className="slds-col slds-size_3-of-12 slds-p-around_large"><SldsPill /></div>
      
      <div className="slds-col slds-size_1-of-1 slds-large-size_1-of-1 slds-p-around_large"><SldsPath /></div>

      <div className="slds-col slds-size_1-of-1 slds-large-size_1-of-1 slds-p-around_large"><SldsDataTable /></div>
  
      <div className="slds-col slds-size_1-of-1 slds-large-size_1-of-1 slds-p-around_large"><SldsProgressIndicator /></div>
      
      
    </div>
  );
};

export default ComponentLibrary;